import { ids } from '@icarros/theme-react';
import styled, { css } from 'styled-components';

interface ResumeWrapperProps {
  isEditOpen: boolean;
  isTransition?: boolean;
}

export const ResumeWrapper = styled.div<ResumeWrapperProps>`
  padding-top: 40px;
  ${({ isEditOpen, isTransition }) =>
    isEditOpen &&
    !isTransition &&
    css`
      display: none;
      visibility: hidden;
    `}

  @media (min-width: 1366px) {
    padding-block-start: 24px !important;
    flex: 1;

    border-right: 1px solid ${ids.color.border.ids_color_border_soft};
    padding-inline-end: 72px !important;
    ${({ isEditOpen }) =>
      isEditOpen &&
      css`
        height: 100vh;
        position: sticky;
        top: 0;
        align-self: flex-start;
        overflow: hidden;
        display: block;
        visibility: visible;
      `}
  }
`;

export const ResumeHeader = styled.div`
  margin-block-end: 40px;
  button {
    flex-direction: row-reverse;
    padding-left: 0;
  }

  > div {
    margin-block-start: 40px;
  }
`;
export const ResumeVehicleTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-block-end: 32px;
`;

export const ResumePlateWrapper = styled.div`
  > div > div {
    width: 100%;
  }
`;

export const ResumeDifferentialsWrapper = styled.div`
  margin-block-start: 80px;
`;

export const ResumeDetailsWrapper = styled.div`
  margin-block-start: 80px;
  > div {
    margin-top: 20px;
    gap: 8px;
  }
  > div > div {
    width: 100%;
  }
  button {
    width: 100%;

    > div:first-of-type {
      margin-left: 0;
    }
  }
`;

export const VehicleDataWrapper = styled.div`
  margin-block-start: 80px;
  > div:first-of-type {
    margin-bottom: 24px;
  }
  > div > div {
    width: 100%;
  }
  button {
    width: 100%;

    > div:first-of-type {
      margin-left: 0;
    }
  }
`;

export const ResumeTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    flex: 1;
  }
  > button {
    width: fit-content;
    flex-direction: row-reverse;
  }
`;

export const ResumeVehicleDifferentialsList = styled.div`
  margin-block-start: 24px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ResumePlanTitle = styled.div`
  display: flex;
  margin-top: 30px;
  gap: 12px;
`;

export const ResumePlanCardTitle = styled.div``;

export const ResumePlanCard = styled.div`
  margin-top: 30px;
  > div {
    flex-direction: column;
    width: 100%;
    padding: 24px;

    > div:nth-of-type(2) {
      > div {
        width: 100%;
        > div:first-of-type {
          margin-left: 0;
        }
      }
    }

    > button {
      margin-top: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      :not(:has(span)) {
        justify-content: center;
      }
    }
  }
`;

export const TitleWithTooltip = styled.div`
  display: flex;
  gap: 8px;

  > div {
    width: fit-content !important;
  }
`;

export const BodyWrapper = styled.div`
  margin-top: 28px !important;
`;

export const ListItemModifier = styled.div`
  > div {
    width: 100%;
  }
  > div > div:first-of-type {
    margin-left: 0;
  }
`;

export const ActionCenterWrapper = styled.div`
  margin-block: 68px;
`;

export const MenuButtonGrid = styled.div`
  margin-top: 35px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  > button {
    text-align: left;
  }
`;

export const CarouselWrapper = styled.div`
  width: 500px;

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const ImagesCarWrapper = styled.div`
  display: flex;
  > div {
    border-radius: 12px;
  }

  img {
    object-fit: cover;
  }
`;

export const DescriptionWrapper = styled.div`
  * {
    word-break: break-word;
  }
`;
